import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import {
  Card,
  Button,
  Input,
  Table,
  Select,
  Dropdown,
  Icon,
  Modal,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { apiPost, apiPut, apiGet } from "../utils/apiConnector"
import { storeApi, productListApi } from "../config/apiUrls"
import { useDispatch, useSelector } from "react-redux"

const EditingLine = (props) => {
  const {
    line,
    name,
    setName,
    ident,
    setIdent,
    product,
    setProduct,
    serial,
    setSerial,
    getLines,
    setModal,
  } = props
  const [products, setProducts] = useState([])
  const { t } = useTranslation()
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const getProducts = () => {
    const storeId = profile.stores.length ? profile.stores[0].id : 0
    if (storeId) {
      apiGet(productListApi + "/" + storeId, {})
        .onOk((res) => {
          console.log(res.data.response)
          setProducts(res.data.response)
        })
        .onFail(() => {})
        .afterAll(() => {})
        .startSingle()
    }
  }
  useEffect(() => {
    getProducts()
    return () => {}
  }, [])
  return (
    <>
      <div>
        <h3>
          <b>{t("Change production line")}</b>
        </h3>
        <div style={{ margin: 20 }}>
          <div>
            <div>{t("Name")}</div>
            <div>
              <Input
                value={name}
                onChange={(e, d) => {
                  setName(d.value)
                }}
                placeholder={line.name}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div style={{ display: "none" }}>
            <div>Идентификатор</div>
            <div>
              <Input
                value={ident}
                onChange={(e, d) => {
                  setIdent(d.value)
                }}
                placeholder={line.ident}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div>
            <div>{t("Product name")}</div>
            <div>
              <Select
                placeholder={line.productName}
                value={product}
                options={products.map((q) => ({
                  key: q.id,
                  value: q.id,
                  text: q.name,
                }))}
                onChange={(e, d) => {
                  setProduct(d.value)
                }}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div style={{ display: "none" }}>
            <div>Серия</div>
            <div>
              <Input
                value={serial}
                onChange={(e, d) => {
                  setSerial(d.value)
                }}
                placeholder={line.serial}
                size="small"
                style={{ marginTop: 10, marginBottom: 10 }}
              />
            </div>
          </div>
          <div>
            <Button
              content={t("Save")}
              positive
              style={{ marginTop: 30 }}
              onClick={() => {
                const req = {}
                req.id = line.id
                if (product) {
                  req.productId = product
                } else {
                  req.productId = line.productId
                }
                if (name) {
                  req.name = name
                } else {
                  req.name = line.name
                }
                if (ident) {
                  req.ident = ident
                } else {
                  req.ident = line.ident
                }
                if (serial) {
                  req.serial = serial
                } else {
                  req.serial = line.serial
                }
                apiPut(storeApi, req)
                  .onOk((res) => {
                    console.log(res)
                    getLines()
                    setModal(false)
                  })
                  .onFail(() => {})
                  .afterAll(() => {})
                  .startSingle()
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default EditingLine
